import { styled } from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 96px 24px;
  flex-direction: column;
  gap: 12px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    margin-top: 0;
  }
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 96px;
`;
